import Backbone from 'backbone';
import _ from 'underscore';

import { UnverifiedModel } from './UnverifiedModel';

export const UnverifiedCollection = Backbone.Collection.extend({

	model: UnverifiedModel,
	
	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
	},

});